import styled from 'styled-components'

const MenuItemRemoveUi = styled.i`
  cursor: pointer;
  margin-left: 5px;
`

export default MenuItemRemoveUi
